import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import styles from './Common.module.css'
import { NoteValidationEngine, RefManager } from '_helpers'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-scroll';
import { StatusGood } from '_components';

var increment = 0;

class PatientCareCenterNoteValidationDetails extends React.Component {
    getIncrement() {
        return increment++;
    }

    linkClicked(section, to) {
        let subsections = to.split('/');
        subsections.forEach((x) => {
            this.props.toggleSectionVisibility({ noteId: this.props.noteId, sectionId: x, visible: true });
        });
        if (to !== '') {
            RefManager.scrollToRef(subsections[subsections.length - 1]);
        }

    }

    renderErrors(section) {
        return (
            <span>
                {Object.keys(this.props.errors)
                    .filter(x => this.props.errors[x].section === section)
                    .map(x => {
                        const error = this.props.errors[x];
                        return (
                            <span key={error.section + error.to + error.label + this.getIncrement()} onClick={() => this.linkClicked(error.section, error.to)}>
                                <span className={styles.error_wrapper} key={error.to} title={error.label}>
                                    <span className={styles.error_icon}><FontAwesomeIcon icon={faExclamationTriangle} /></span>
                                    <span className={styles.error_name}>{error.label}</span>
                                </span>
                            </span>
                        )
                    })
                }
            </span >
        );
    }

    handleClick() {
        this.props.toggleVisibility({ noteId: this.props.noteId, visible: !this.props.visible });
    }

    render() {
        return (
            <span>
                {this.props.errors.length > 0 &&
                    <div className={styles.scroll_div}>
                        {Object.keys(this.props.sections)
                            .map(x => {
                                const section = this.props.sections[x];
                                return (
                                    <span className={styles.section_wrapper} key={section}>
                                        <span className={styles.section_name}>{section}</span>
                                        {this.renderErrors(section)}
                                    </span>
                                )
                            })
                        }
                    </div>
                }
                {this.props.errors.length === 0 &&
                    <div className={styles.no_errors}>
                        Great Job!  Your note validated <span className={styles.success}>successfully</span>.  You may now finalize the note.
                        <br />
                        <Link to='charges_compute' containerId={this.props.noteId} spy={true} smooth={true}>
                            <StatusGood size='extra-large' onClick={() => this.handleClick()} />
                        </Link>
                    </div>
                }
            </span>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        toggleVisibility: bindActionCreators(noteActions.toggleValidationVisibility, dispatch),
        toggleSectionVisibility: bindActionCreators(noteActions.toggleSectionVisibility, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let visible = state.ui.notes[noteId].validationVisible;

    let errors = NoteValidationEngine.getErrors(state);
    let sections = errors.length > 0 ? [...new Set(errors.map(x => x.section))] : [];

    return {
        noteId,
        errors,
        sections,
        visible
    };
}

const connectedPatientCareCenterNoteValidationDetails = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteValidationDetails);
export { connectedPatientCareCenterNoteValidationDetails as PatientCareCenterNoteValidationDetails };

